module.exports = __webpack_public_path__ + "img/rule.697ca2c2.png";